import { Box, Typography } from '@mui/material';
import { VacancyGroupLinkField } from 'domain/shared/newVacancy';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import PositionSlotEmployeeField from './PositionSlotEmployeeField';

const PositionSlotWorkerVacancyField = ({ label, ...props }: FieldProps) => {
  const { getValue: getEmployeeAlias } = useFieldHelper<string | null>({ source: 'employeeAlias' });
  const { getValue: getVacancyGroupId } = useFieldHelper<string | null>({ source: 'vacancyGroupId' });
  const employeeAlias = getEmployeeAlias();
  const vacancyGroupId = getVacancyGroupId();

  const employeeField = <PositionSlotEmployeeField {...props} source="employeeAlias" label={label} />;
  const vacancyField = (
    <VacancyGroupLinkField {...props} source="vacancyGroupId" nameSource="vacancyGroupName" label={label} />
  );

  if (employeeAlias && vacancyGroupId) {
    return (
      <Box display="flex" alignItems="center" gap={0.5}>
        {employeeField}
        <Typography component="span" color="textSecondary">
          /
        </Typography>
        {vacancyField}
      </Box>
    );
  }

  if (employeeAlias) {
    return employeeField;
  }

  if (vacancyGroupId) {
    return vacancyField;
  }

  return (
    <Typography variant="body1" color="textSecondary" {...props}>
      —
    </Typography>
  );
};

export default PositionSlotWorkerVacancyField;
